import React from "react";

export function Footer() {
  return (
      <footer>
        Made with <span aria-label={"love"}>❤️</span>️ by <a href="https://ddiner.dev">Dominik Diner</a>
      </footer>
  );
}
